export default __webpack_public_path__ + "static/HQ8hvgcY-d57e6977596158b4a94da98f76a1e841.jpeg";